import React from 'react';

function DealFormModal({ show, editing, form, setForm, companies, contacts, pipelineData, onSubmit, onClose }) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{editing ? 'Redigera affärsmöjlighet' : 'Ny affärsmöjlighet'}</h3>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>
        <form onSubmit={onSubmit}>
          <div className="form-grid">
            <div className="form-group form-group-full">
              <label>Namn på affärsmöjlighet *</label>
              <input type="text" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="t.ex. Agil projektledning - Företag AB" required />
            </div>

            <div className="form-group">
              <label>Företag</label>
              <select value={form.b2bCompanyId} onChange={(e) => setForm({ ...form, b2bCompanyId: e.target.value })}>
                <option value="">Välj företag...</option>
                {companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
              </select>
            </div>

            <div className="form-group">
              <label>Kontaktperson</label>
              <select value={form.contactId} onChange={(e) => setForm({ ...form, contactId: e.target.value })}>
                <option value="">Välj kontakt...</option>
                {contacts.map(c => <option key={c.id} value={c.id}>{c.firstName} {c.lastName}</option>)}
              </select>
            </div>

            <div className="form-group">
              <label>Pipeline-steg</label>
              <select value={form.stageId} onChange={(e) => setForm({ ...form, stageId: e.target.value })}>
                {pipelineData.filter(s => !s.isLostStage).map(s => <option key={s.id} value={s.id}>{s.name}</option>)}
              </select>
            </div>

            <div className="form-section-title">Ekonomi</div>

            <div className="form-group">
              <label>Förväntat värde (kr)</label>
              <input type="number" value={form.expectedValue} onChange={(e) => setForm({ ...form, expectedValue: e.target.value })} placeholder="50000" />
            </div>

            <div className="form-group">
              <label>Sannolikhet (%)</label>
              <input type="range" min="0" max="100" step="10" value={form.probability} onChange={(e) => setForm({ ...form, probability: parseInt(e.target.value) })} />
              <span className="range-value">{form.probability}%</span>
            </div>

            <div className="form-group">
              <label>Förväntad avslut</label>
              <input type="date" value={form.expectedCloseDate} onChange={(e) => setForm({ ...form, expectedCloseDate: e.target.value })} />
            </div>

            <div className="form-group">
              <label>Källa</label>
              <select value={form.source} onChange={(e) => setForm({ ...form, source: e.target.value })}>
                <option value="">Välj...</option>
                <option value="Hemsida">Hemsida</option>
                <option value="Referens">Referens</option>
                <option value="LinkedIn">LinkedIn</option>
                <option value="Event">Event/Mässa</option>
                <option value="Kall kontakt">Kall kontakt</option>
                <option value="Återkommande">Återkommande kund</option>
                <option value="Annat">Annat</option>
              </select>
            </div>

            <div className="form-section-title">Kursdetaljer</div>

            <div className="form-group">
              <label>Kurstyp</label>
              <select value={form.courseType} onChange={(e) => setForm({ ...form, courseType: e.target.value })}>
                <option value="custom">Skräddarsydd</option>
                <option value="standard">Standardkurs</option>
                <option value="lecture">Föreläsning</option>
              </select>
            </div>

            <div className="form-group">
              <label>Antal deltagare</label>
              <input type="number" value={form.estimatedParticipants} onChange={(e) => setForm({ ...form, estimatedParticipants: e.target.value })} placeholder="15" />
            </div>

            <div className="form-group">
              <label>Önskad plats</label>
              <input type="text" value={form.preferredLocation} onChange={(e) => setForm({ ...form, preferredLocation: e.target.value })} placeholder="t.ex. Kundens kontor, Stockholm" />
            </div>

            <div className="form-group">
              <label>Önskade datum</label>
              <input type="text" value={form.preferredDates} onChange={(e) => setForm({ ...form, preferredDates: e.target.value })} placeholder="t.ex. Q2 2026, flexibelt" />
            </div>

            <div className="form-group form-group-full">
              <label>Kursbeskrivning</label>
              <textarea value={form.customCourseDescription} onChange={(e) => setForm({ ...form, customCourseDescription: e.target.value })} rows="3" placeholder="Beskriv kundens behov och önskemål..." />
            </div>

            <div className="form-group form-group-full">
              <label>Anteckningar</label>
              <textarea value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} rows="2" />
            </div>
          </div>

          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Avbryt</button>
            <button type="submit" className="btn btn-primary">{editing ? 'Spara ändringar' : 'Skapa deal'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function ActivityFormModal({ show, form, setForm, activityTypes, onSubmit, onClose }) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Lägg till aktivitet</h3>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label>Aktivitetstyp *</label>
            <select value={form.activityTypeId} onChange={(e) => setForm({ ...form, activityTypeId: e.target.value })} required>
              <option value="">Välj typ...</option>
              {activityTypes.filter(t => t.slug !== 'stage-change').map(t => (
                <option key={t.id} value={t.id}>{t.icon} {t.name}</option>
              ))}
            </select>
          </div>
          <div className="form-group">
            <label>Rubrik *</label>
            <input type="text" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="t.ex. Uppföljningssamtal" required />
          </div>
          <div className="form-group">
            <label>Beskrivning</label>
            <textarea value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows="3" />
          </div>
          <div className="form-group">
            <label>Schemalagd tid (valfritt)</label>
            <input type="datetime-local" value={form.scheduledAt} onChange={(e) => setForm({ ...form, scheduledAt: e.target.value })} />
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-secondary" onClick={onClose}>Avbryt</button>
            <button type="submit" className="btn btn-primary">Lägg till</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function EmailDetailModal({ email, onClose }) {
  if (!email) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large email-viewer-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{email.direction === 'inbound' ? '⬇️ Inkommande' : '⬆️ Utgående'} e-post</h3>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>
        <div className="email-viewer-content">
          <div className="email-viewer-meta">
            <div className="meta-row">
              <span className="meta-label">Från:</span>
              <span className="meta-value">{email.senderName} &lt;{email.senderEmail}&gt;</span>
            </div>
            <div className="meta-row">
              <span className="meta-label">Till:</span>
              <span className="meta-value">{email.toRecipients?.map(r => r.name || r.email).join(', ')}</span>
            </div>
            {email.ccRecipients?.length > 0 && (
              <div className="meta-row">
                <span className="meta-label">Kopia:</span>
                <span className="meta-value">{email.ccRecipients.map(r => r.name || r.email).join(', ')}</span>
              </div>
            )}
            <div className="meta-row">
              <span className="meta-label">Datum:</span>
              <span className="meta-value">
                {new Date(email.receivedAt || email.sentAt).toLocaleString('sv-SE', {
                  weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
                })}
              </span>
            </div>
            <div className="meta-row">
              <span className="meta-label">Ämne:</span>
              <span className="meta-value email-subject-full">{email.subject || '(Inget ämne)'}</span>
            </div>
          </div>
          <div className="email-body-container">
            {email.bodyHtml ? (
              <iframe title="Email content" srcDoc={email.bodyHtml} className="email-body-iframe" sandbox="allow-same-origin" />
            ) : (
              <pre className="email-body-text">{email.bodyText || email.bodyPreview}</pre>
            )}
          </div>
          <div className="email-viewer-actions">
            {email.webLink && (
              <a href={email.webLink} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
                🔗 Öppna i Outlook
              </a>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

function UnmatchedEmailsModal({ show, emails, count, creatingLead, onCreateLead, onClose }) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Omatchade mejl ({count})</h3>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-content">
          <p className="text-muted" style={{marginBottom: '1rem', fontSize: '0.85rem'}}>
            Dessa mejl kunde inte matchas till befintliga kontakter.
            De sparas i max 7 dagar. Klicka på ett mejl för att skapa ett lead.
          </p>
          {emails.length === 0 ? (
            <p className="text-center text-muted">Inga omatchade mejl</p>
          ) : (
            <div className="email-list">
              {emails.map(email => (
                <div key={email.id} className={`email-item unmatched ${email.direction}`}>
                  <span className="email-direction-icon">{email.direction === 'inbound' ? '⬇️' : '⬆️'}</span>
                  <div className="email-content">
                    <div className="email-header">
                      <span className="email-sender">
                        {email.direction === 'inbound'
                          ? (email.senderName || email.senderEmail)
                          : `Till: ${email.toRecipients?.[0]?.email || 'Okänd'}`
                        }
                      </span>
                      <span className="email-date">{new Date(email.receivedAt || email.sentAt).toLocaleDateString('sv-SE')}</span>
                    </div>
                    <div className="email-subject">{email.subject}</div>
                    <div className="email-preview">{email.bodyPreview}</div>
                    <div className="unmatched-email-actions">
                      <button className="btn btn-sm btn-primary" onClick={(e) => { e.stopPropagation(); onCreateLead(email.id, false); }} disabled={creatingLead === email.id}>
                        {creatingLead === email.id ? 'Skapar...' : '👤 Skapa lead'}
                      </button>
                      <button className="btn btn-sm btn-success" onClick={(e) => { e.stopPropagation(); onCreateLead(email.id, true); }} disabled={creatingLead === email.id}>
                        {creatingLead === email.id ? 'Skapar...' : '📊 Lead + Deal'}
                      </button>
                      {email.webLink && (
                        <a href={email.webLink} target="_blank" rel="noopener noreferrer" className="btn btn-sm btn-secondary" onClick={(e) => e.stopPropagation()}>
                          🔗 Outlook
                        </a>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

function EmailComposeModal({ show, form, setForm, sending, onSend, onClose }) {
  if (!show) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Skicka e-post</h3>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <label>Till *</label>
            <input type="email" value={form.to} onChange={(e) => setForm({ ...form, to: e.target.value })} placeholder="email@example.com" required />
          </div>
          <div className="form-group">
            <label>Ämne *</label>
            <input type="text" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} placeholder="Ämne för mejlet" required />
          </div>
          <div className="form-group">
            <label>Meddelande *</label>
            <textarea value={form.body} onChange={(e) => setForm({ ...form, body: e.target.value })} rows={8} placeholder="Skriv ditt meddelande här..." required />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={sending}>Avbryt</button>
          <button type="button" className="btn btn-primary" onClick={onSend} disabled={sending}>
            {sending ? 'Skickar...' : 'Skicka'}
          </button>
        </div>
      </div>
    </div>
  );
}

export { DealFormModal, ActivityFormModal, EmailDetailModal, UnmatchedEmailsModal, EmailComposeModal };
